module.exports = __webpack_public_path__ + "img/global-2012-german-delegation.4aa1d71f.jpg";